export default __webpack_public_path__ + "static/media/family.9cf605f5.png";